import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService, SecurityUser } from '../security/security.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'auth-callback',
  templateUrl: './auth.component.html'
})
export class ProfCallbackComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  isAuthenticated: boolean;
  isExpanded = false;
  currentUrl: string;

  constructor(private router: Router,
    public authService: MsalService,
    public securityService: SecurityService,
    private route: ActivatedRoute) {
    this.securityService.getCurrentUser().subscribe((usr: any) => {
      this.currentUser = usr;
    });
  }

  async ngOnInit(): Promise<any> {
    await this.authService.instance.initialize();
    const urlParams = new URLSearchParams(this.route.snapshot.fragment ?? "");
    let p = urlParams.get('p');

    if (p) {
      let profile = JSON.parse(decodeURIComponent(p));
      this.authService.instance.setActiveAccount(profile);
      this.router.navigate(['/']).then(() => window.location.reload());

    }
  }

}
